var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('right-structure',{attrs:{"Pdatas":_vm.infoData}},[_c('pre',{attrs:{"slot":"q_code"},slot:"q_code"},[_vm._v(_vm._s(JSON.stringify(_vm.requestBody, null, 4)))]),_vm._v(" "),_c('pre',{attrs:{"slot":"r_code"},slot:"r_code"},[_vm._v(_vm._s(JSON.stringify(_vm.responseCode, null, 4)))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25282492","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doc/deprecated/carSearch/getInventoryRecord.vue
// module id = H7u2
// module chunks = 0